module.exports = __webpack_public_path__ + "static/media/BMAT_UCAT.ab38406e.png";